import { Component } from '@angular/core';
import { map, Observable } from 'rxjs';
import { LexbeDoc } from '@models/doc.model';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { BaseComponent } from 'src/app/components/base.component';
import { CustomCodingFieldsManager } from '@models/review/custom-coding-fields-manager';
import { ReviewManager } from '@managers/review.manager';
import { DocChangeSetReferenceResource } from '@models/resource/doc-change-set-reference.resource';
import { NotificationManager } from '@managers/notification.manager';
import { MatDialog } from '@angular/material/dialog';
import { CodingField } from '@models/field/coding-field.model';
import { DocViewerAddCodingFieldComponent } from '../../dialogs/doc-viewer-add-coding-field/doc-viewer-add-coding-field.component';

@Component({
    selector: 'lex-doc-viewer-coding-tab',
    templateUrl: './doc-viewer-coding-tab.component.html',
    styleUrls: ['./doc-viewer-coding-tab.component.scss'],
    standalone: false
})
export class DocViewerCodingTabComponent extends BaseComponent {
	public currentDocument$: Observable<LexbeDoc> = this.docViewerStore.currentDocument$;
	public lastChangeSet$: Observable<DocChangeSetReferenceResource> = this.docViewerStore.simpleState$.pipe(map((state) => state.lastChangeSet));
	public toolTipMessage$: Observable<string> = this.lastChangeSet$.pipe(map((lastChangeSet) =>
		`Name: ${lastChangeSet.documentName} - Last Updated: ${lastChangeSet.createdAt}`));

	constructor(
		public customCodingFieldsManager: CustomCodingFieldsManager,
		public docViewerStore: DocViewerStore,
		private reviewManager: ReviewManager,
		private notificationManager: NotificationManager,
		private matDialog: MatDialog
	) {
		super();
	}

	public sameAsLastIt(): void {
		this.docViewerStore.updateState((current) => {
			current.projectChangeSets = [current.lastChangeSet];
			return current;
		}).subscribe(() => {
			this.reviewManager.refreshDocument(true);
			this.notificationManager.displaySnackBarMessage({
				message: "Applied changes."
			})
		});
	}

	public addNewField(): void {
		this.matDialog.open(DocViewerAddCodingFieldComponent).afterClosed().subscribe((data: CodingField | string) => {
			if (!data) return;
			this.customCodingFieldsManager.retrieve(true);
		});
	}
}
